@if (
  (options && options.metadata && options.metadata.url) ||
  (options && options.metadata && options.metadata.abstract)
) {
  <button
    mat-icon-button
    tooltip-position="below"
    matTooltipShowDelay="500"
    [matTooltip]="'igo.geo.metadata.show' | translate"
    [color]="color()"
    (click)="openMetadata(options.metadata)"
  >
    <mat-icon>info</mat-icon>
  </button>
}
